import React from "react";
import CustomTimeSheetTable from "../../../components/CustomTimeSheetTable";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import { toast } from "react-toastify";
import { getCookieData, getUserIdTokenForIonTime } from "../../../helper/api";

interface MyTimesheetReportProps {
  onClose?: () => void;
  hideHomeButton?: boolean;
}

const MyTimesheetReport: React.FC<MyTimesheetReportProps> = ({
  onClose,
  hideHomeButton = false,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const query = getCookieData("timesheetsReport");
  const state = location.state as { id: string | null } | undefined; // Assuming state is an object with an 'id' property
  const getUserId = getUserIdTokenForIonTime();
  const cookeei = query ? JSON.parse(query) : null;
  const date = cookeei && cookeei?.id ? cookeei?.id.split("-") : null;
  const memberID = cookeei && cookeei?.memberID ? cookeei?.memberID : getUserId;

  // Access 'id' from state if it exists
  const routeState = date ? date : state?.id ? state?.id.split("-") : null;
  const startdate = routeState ? moment(routeState[0]).toDate() : new Date();
  const enddate = routeState ? moment(routeState[1]).toDate() : new Date();

  if (!startdate || !enddate) {
    navigate(-1);
    toast.error("Timesheet record has missing start and end date");
  }

  return (
    startdate &&
    enddate && (
      <div>
        {cookeei && cookeei?.role === "admin" && (
          <button
            onClick={() => (onClose ? onClose() : window.close())}
            className="flex  items-center px-4 py-2 mb-4 text-sm bg-red-700 hover:bg-red-800 text-white rounded-lg focus:outline-none "
          >
            Go Back
          </button>
        )}
        <CustomTimeSheetTable
          memberID={Number(memberID)}
          startDate={startdate}
          endDate={enddate}
          previewFlag={true}
          reportType="update"
          showHomeButton={!hideHomeButton}
          employeeNameData={cookeei && cookeei?.employeeNameData}
          employeeIDData={cookeei && cookeei?.employeeIDData}
          showapproveReject={cookeei?.role === "admin" ? true : false}
          userRoleType={cookeei?.role}
          modelClose={cookeei?.role === "admin" ? onClose : undefined}
        />
      </div>
    )
  );
};

export default MyTimesheetReport;
